module.exports = __webpack_public_path__ + "img/call-text-section.d082b7e0.svg";